import { useEffect, useState } from 'react';

import type { Point } from '../types/point.js';

/**
 * @internal
 * Hook that handles the mouse position
 * @param shouldUpdatePosition - boolean that determines whether the mouse position needs to be updated or not.
 * @returns mouse position
 */
export const useMousePosition = (shouldUpdatePosition: boolean) => {
  const [mousePosition, setMousePosition] = useState<Point>({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const updateMousePosition = ({ clientX, clientY }: MouseEvent) => {
      if (shouldUpdatePosition) {
        setMousePosition({
          x: clientX,
          y: clientY,
        });
      }
    };

    window.addEventListener('mousemove', updateMousePosition);

    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
    };
  }, [shouldUpdatePosition]);

  return mousePosition;
};
